import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bch_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const submitLead = (type, data) => api.post("/leads", { type, data });

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg).filter(Boolean).join(" ");
  return err?.message || "Something went wrong. Please try again.";
}
